import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MdChat, MdContentCopy, MdPerson } from 'react-icons/md';
import { openContactChat } from '../api/messages';
import { selectContact } from '../store/messageSlice';

// Un contatto inviato in chat, come su WhatsApp: prima arrivava come testo
// grezzo «BEGIN:VCARD…» (richiesta del 04/10/2026). Il server lo legge già
// (apps/messages/vcard.py) e manda nome e numeri in `msg.contacts`.
function Biglietto({ contatto, connection }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [stato, setStato] = useState('');
  const numero = contatto.numeri[0];
  const scrivi = async e => {
    e.stopPropagation();
    setStato('apro');
    try {
      const { data } = await openContactChat(connection, numero.waid ? `+${numero.waid}` : numero.numero, contatto.nome);
      dispatch(selectContact(data));
      navigate(`/chat?contact=${data.id}`);
      setStato('');
    } catch (err) { setStato(err.response?.data?.numero?.[0] || 'Chat non aperta. Riprova.'); }
  };
  const copia = async e => {
    e.stopPropagation();
    try { await navigator.clipboard.writeText(numero.numero); setStato('copiato'); }
    catch (_) { setStato('Copia non riuscita'); }
    setTimeout(() => setStato(s => (s === 'copiato' ? '' : s)), 1500);
  };
  return <div className="biglietto-contatto">
    <div className="biglietto-testa">
      <span className="biglietto-avatar" aria-hidden="true"><MdPerson size={26} /></span>
      <span className="biglietto-dati"><strong>{contatto.nome}</strong>
        {contatto.numeri.map(n => <span key={n.numero} className="biglietto-numero">{n.numero}{n.etichetta ? ` · ${n.etichetta}` : ''}</span>)}
      </span>
    </div>
    {numero && <div className="biglietto-azioni">
      {connection && <button type="button" onClick={scrivi} disabled={stato === 'apro'}><MdChat size={17} /> {stato === 'apro' ? 'Apro…' : 'Scrivi'}</button>}
      <button type="button" onClick={copia}><MdContentCopy size={16} /> {stato === 'copiato' ? 'Copiato' : 'Copia numero'}</button>
    </div>}
    {stato && !['apro', 'copiato'].includes(stato) && <p role="alert" className="text-xs px-3 pb-2">{stato}</p>}
  </div>;
}

export default function BigliettiContatto({ msg }) {
  return <div className="biglietti-contatto">
    {msg.contacts.map((c, i) => <Biglietto key={i} contatto={c} connection={msg.connection} />)}
  </div>;
}
